import Vue from 'vue'
import VueGtag from 'vue-gtag'
import 'dotenv/config'
import './plugins/fontawesome'
import './plugins/leaflet';
import './plugins/socialShare';
import './plugins/vuemeta';
// import gtag from './plugins/gtag';
import App from './App.vue'
import router from './router/index.js'
import store from './store/index'
import ElementUI from 'element-ui'
import locale from 'element-ui/lib/locale/lang/zh-TW'
import 'element-ui/lib/theme-chalk/index.css'
import '@/assets/backstage/style/style.scss'
import '@/mixins/index'

Vue.use(VueGtag, {
  config: {
      id: process.env.VUE_APP_GA4_TRACKING_ID,
  }
})

Vue.use(ElementUI, { locale })

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
